import * as React from 'react';

import { Toaster as SonnerToaster, toast } from 'sonner';

import { Button } from '../button/button.tsx';
import { Icon } from '../icon/icon.tsx';

import './toaster.css';

interface ToasterProps extends React.HTMLAttributes<HTMLDivElement> {}

const Toaster = React.forwardRef<HTMLDivElement, ToasterProps>(
  ({ ...props }, ref) => {
    return (
      <div ref={ref} {...props}>
        <SonnerToaster visibleToasts={4} />
      </div>
    );
  },
);

const CustomToast: React.FC<{
  variant: 'default' | 'error' | 'success' | 'warning';
  title?: string;
  description?: string;
  toastId: number | string;
  buttonText?: string;
  buttonAction?: () => void;
}> = props => {
  return (
    <div className={`toast toast-${props.variant}`}>
      <div className="toast-wrapper">
        {props.variant !== 'default' && (
          <div className="toast-icon">
            <Icon type={props.variant} size="large" />
          </div>
        )}
        <div className="toast-content">
          <div className="toast-data">
            {props.title && <div className="toast-title">{props.title}</div>}
            {props.description && (
              <div className="toast-description">{props.description}</div>
            )}
          </div>
          {props.buttonText && props.buttonAction && (
            <div className="toast-button">
              <Button asToast type="button" onClick={props.buttonAction}>
                {props.buttonText}
              </Button>
            </div>
          )}
        </div>
        <button
          type="button"
          className="toast-exit"
          onClick={() => toast.dismiss(props.toastId)}
        >
          <Icon type="x" size="small" className="toast-exit-fill" />
        </button>
      </div>
    </div>
  );
};

const dispatchToast = (props: {
  variant: 'default' | 'error' | 'success' | 'warning';
  title?: string;
  description?: string;
  duration: number;
  buttonText?: string;
  buttonAction?: () => void;
  id?: number | string;
}) => {
  toast.custom(toastId => <CustomToast toastId={toastId} {...props} />, {
    duration: props.duration,
    ...(props.id ? { id: props.id } : {}),
  });
};

export { Toaster, dispatchToast };
